export const TIME = 2 * 60 * 1000; // 2 minutes
